import { render } from "./ConfigsModal.vue?vue&type=template&id=25ee4a0a&scoped=true"
import script from "./ConfigsModal.vue?vue&type=script&lang=js"
export * from "./ConfigsModal.vue?vue&type=script&lang=js"

import "./ConfigsModal.vue?vue&type=style&index=0&id=25ee4a0a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ee4a0a"]])

export default __exports__